import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const AuthMiddleware = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const checkAuth = () => {
            if (!localStorage.getItem("token") || !localStorage.getItem("permissions" || !localStorage.getItem("id"))) {
                localStorage.clear();

                const publicPaths = ["/","/login", "/forgot-password", "/forgot-password/reset-password"];
                if (!publicPaths.includes(location.pathname)) {
                    toast.error("You are not authenticated, please log in.");
                    navigate("/login", { state: { from: location } });
                }
            } 
        };

        checkAuth();

        const intervalId = setInterval(checkAuth, 1000); // Check every second

        return () => clearInterval(intervalId);
    }, [navigate, location]);

    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    );
};

export default AuthMiddleware;